import { render, staticRenderFns } from "./vad-kostar-en-rekrytering.vue?vue&type=template&id=1065f952&scoped=true&"
import script from "./vad-kostar-en-rekrytering.vue?vue&type=script&lang=ts&"
export * from "./vad-kostar-en-rekrytering.vue?vue&type=script&lang=ts&"
import style0 from "./vad-kostar-en-rekrytering.vue?vue&type=style&index=0&lang=css&"
import style1 from "./vad-kostar-en-rekrytering.vue?vue&type=style&index=1&id=1065f952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1065f952",
  null
  
)

/* custom blocks */
import block0 from "./vad-kostar-en-rekrytering.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
